<template>
  <div class="create-clinic-box tab-scroll-owner" v-loader.opacity.tab="loading">
    <div class="alert" :class="alert.class" role="alert" v-if="alert.message">
      <span v-html="alert.message"></span>
      <button type="button" class="btn-close" aria-label="Close" @click="alert.message = null"></button>
    </div>

    <vee-form v-slot="{ handleSubmit, setFieldValue, setFieldTouched, validate, resetForm, meta  }" as="div" :on-invalid-submit="onInvalidSubmit">
      <form @submit.prevent.stop="handleSubmit(doSave)">
        <ClinicFormData
          v-if="clinic.locale && isDataReady"
          :clinic="clinic"
          :is_creating="true"
          :parent_clinic_options="parentClinicOptions"
          @option-selected="setSelectedOptions"
          @security-changed="securityChanged"
          @parent-changed="parentClinicChanged"
          :setFieldValue="setFieldValue"
          :setFieldTouched="setFieldTouched"
          :validateForm="validate"
          :resetVeeForm="resetForm"
          :formMeta="meta"/>

        <div class="action-bar" @wheel.prevent>
          <button class="btn btn-success" type="submit" name="button" data-test="btnSave" v-if="hasFormChanged">
            <span>{{ $t('createClinic.save') }}</span>
          </button>
          <button class="btn btn-secondary" type="button" name="button" data-test="btnCancel" @click="$router.back()">
            <span>{{ $t("cancel") }}</span>
          </button>
        </div>
      </form>
    </vee-form>

  </div>
</template>

<style lang="scss" scoped>
.action-bar {
  position:                           sticky;
  bottom:                             0;
  z-index:                            2;
  background:                         var(--Shades-W);
}
</style>

<script>
import ClinicFormData from '../ClinicFormData.vue'

export default {
  name: 'ClinicCreateTab',
  components: {
    ClinicFormData
  },
  data: () => ({
    loading: false,
    alert: {
      message: null,
      class: null
    },
    clinic: {
      name: '',
      fantasyName: '',
      document: '',
      ownerDocument: '',
      email: '',
      telephone1: '',
      telephone2: '',
      address: '',
      addressNumber: '',
      district: '',
      city: '',
      state: '',
      systemConfiguration: {
        security: null,
      },
      postalCode: '',
    },
    isDataReady: false,
    hasFormChanged: false,
    changedFormItems: [],
    initialForm: {},
    parentClinic: null,
    parentClinicOptions: [
      {value: null, label: 'None'}
    ],
  }),
  watch: {
    clinic: {
      immediate: true,
      handler(newValue) {
        if (this.isDataReady)
          this.checkFormChange(newValue, 'clinic')
    }, deep: true},
    parentClinic: {
      immediate: true,
      handler(newValue) {
        if (this.isDataReady)
          this.checkFormChange(newValue, 'parentClinic')
    }, deep: true},
  },
  mounted() {
    this.initialize()
  },
  methods: {
    async initialize() {
      this.loading = true
      NProgress.start()
      try {
        let response = await this.$clinicService.create();

        this.clinic.country = this.$utils.getCountryCodeFromBrowserLocale()
        this.clinic.locale = response.clinicTemplate.locale
        this.clinic.mandatoryDocument = response.clinicTemplate.mandatoryDocument
        this.clinic.shareCcEmails = response.clinicTemplate.shareCcEmails

        this.parentClinicOptions = [
          { value: null, label: this.$t('createClinic.none') }
        ]

        response.parentClinics.forEach(async (o) => {
          o.value = o.id;
          o.label = o.name;
          await this.parentClinicOptions.push(o)
        })
        // this.clinic.systemConfiguration.security = null

        this.isDataReady = true

        const formWrap = {
          clinic: this.clinic,
          parentClinic: this.parentClinic
        }

        this.initialForm = _.cloneDeep(formWrap)

        this.$nextTick(() => {
          this.hasFormChanged = false
          this.changedFormItems = []
        })

        this.isDataReady = true
      } catch (err) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'request_error', 'danger')
      }
      this.loading = false
      NProgress.done(true)
    },
    checkFormChange(value, obj) {
      let hasObj = this.changedFormItems.includes(obj)
      if (JSON.stringify(value) === JSON.stringify(this.initialForm[obj])) {
        if (hasObj) {
          let index = this.changedFormItems.indexOf(obj)
          this.changedFormItems.splice(index, 1)
        }

        if (this.changedFormItems.length > 0)
          return

        this.hasFormChanged = false
      } else {
        if (!hasObj)
          this.changedFormItems.push(obj)

        this.hasFormChanged = true
      }
    },
    setSelectedOptions(value) {
      this.clinic.country = value.country
      this.clinic.mandatoryDocument = value.mandatoryDocument
      this.clinic.locale = value.locale
    },
    parentClinicChanged(value) {
      this.parentClinic = value.parentClinic
    },
    securityChanged(value) {

      // TODO move to clinic-service
      // let systemConfiguration = this.clinic.systemConfiguration.security ? this.clinic.systemConfiguration.security : {}
      // let security = systemConfiguration.security ? systemConfiguration.security : {}
      let security = {
        mfaMode: null
      }
      security.mfaMode = value.mfaMode
      this.clinic.systemConfiguration.security = security
    },
    onInvalidSubmit({ errors }) {
      this.$utils.scrollToFirstInvalidField(errors)
    },
    async doSave() {
      try {
        let params = {
          clinic: this.clinic
        }

        if (this.parentClinic) {
          params['parentClinic'] = this.parentClinic
        }

        this.loading = true
        NProgress.start()
        let response = await this.$clinicService.saveClinic(params);
        this.$message.popup(this, 'clinic.createdSuccess', 'operationSuccess', 'success')

        this.$router.push({name: 'clinic-show', params: {clinicID: response.result.id}, query: {tab: 'data'}})
      } catch (err) {
        this.$message.popup(this, 'general.createdError', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'general.createdError', 'danger')
      }
      NProgress.done(true)
      this.loading = false
    }
  }
}
</script>
